import React from 'react';
import { useLanguage } from '../../../contexts/LanguageContext';
import { FaUsers, FaInstagram, FaHandsHelping, FaVideo, FaUserFriends, FaMapMarkedAlt, FaNetworkWired } from 'react-icons/fa';
import GambarKomunitas from '../../../assets/gambar-logo-komunitas.JPEG';
import GambarRiset from '../../../assets/riset.png';
import GambarEdukasi from '../../../assets/edukasip.png';
import '../../styles/programme.css';


const ProgrammeSection = () => {
  const { language } = useLanguage();

  const content = {
    id: {
      strapline: "MENDORONG PERUBAHAN SISTEM PERSAMPAHAN MELALUI AKTIVITAS KERELAWANAN",
      focusTitle: "FOKUS KEGIATAN",
      focusList: [
        {
          title: "Komunitas Digital dan Jaringan Persampahan Nasional",
          desc: "FORPASI memiliki berbagai grup diskusi (via WA) untuk menjejaringkan berbagai pihak seluruh Indonesia mengenai isu sampah, dan menyelenggarakan WEBINAR DISKUSI LESTARI secara virtual untuk mendiskusikan isu-isu penting dalam persampahan, maupun kegiatan secara offline/luring.",
          image: GambarKomunitas
        },
        {
          title: "Riset dan\nAdvokasi Kebijakan",
          desc: "FORPASI melakukan riset untuk memberikan masukan terhadap kebijakan dalam bentuk policy brief, riset sederhana / lean research, maupun dengan melakukan audiensi langsung dengan para pemangku kebijakan juga lembaga sektor lain (privat dan nonprofit/CSO).",
          image: GambarRiset
        },
        {
          title: "Edukasi, Kampanye, dan Program Strategis",
          desc: "FORPASI menyediakan program kerelawanan, aktivitas edukasi, dan kampanye untuk meningkatkan pemahaman publik terhadap persampahan, serta melakukan pendukungan program strategis dalam mengelola sampah secara langsung melalui Yayasan Asa Indonesia Lestari.",
          image: GambarEdukasi
        },
      ],
      impactTitle: "DAMPAK FORPASI DALAM ANGKA",
      impacts: [
        { icon: <FaUsers />, value: "950+", label: "Anggota komunitas digital (WhatsApp)" },
        { icon: <FaInstagram />, value: "606", label: "Pengikut Instagram" },
        { icon: <FaHandsHelping />, value: "30.000+", label: "Engagement media sosial" },
        { icon: <FaVideo />, value: "20", label: "Rekaman webinar & kegiatan" },
        { icon: <FaUserFriends />, value: "45+", label: "Relawan terlibat" },
        { icon: <FaMapMarkedAlt />, value: "20", label: "Area cakupan koordinator wilayah" },
        { icon: <FaNetworkWired />, value: "20+", label: "Lembaga kolaborator" },
      ],
      mapTitle: "Peta Program & Jaringan Kolaborasi (Tentatif)",
      mapNote: "Peta akan ditambahkan kemudian (tentatif). Sementara ini, gunakan placeholder/embedding bila sudah tersedia.",
      ctaTitle: "Ingin berpartisipasi langsung?",
      ctaText:
        "Kami mempersiapkan kegiatan bagi kalian yang berminat berkontribusi untuk mendorong sistem persampahan.",
      ctas: [
        { href: "https://www.indorelawan.org/organization/64f53040c147a300219891ec", text: "Jadi Relawan via Indorelawan" },
        { href: "https://forms.gle/nLXwtjaML9hYB9iz8", text: "Jadi Koordinator Wilayah" },
        { href: "https://chat.whatsapp.com/Fxr1PVSm9nA6G6dM8coGMY", text: "Gabung Komunitas Diskusi WA" },
      ],
    },
    en: {
      heroTitle: "Programme",
      strapline: "DRIVING WASTE-SYSTEM CHANGE THROUGH VOLUNTEER ACTION",
      focusTitle: "FOCUS AREAS",
      focusList: [
        {
          title: "Digital Community & National Waste Network",
          desc: "FORPASI hosts discussion groups (via WA) to connect stakeholders across Indonesia on waste issues, and runs WEBINAR DISKUSI LESTARI virtually to discuss key waste topics alongside offline activities."
        },
        {
          title: "Research &\nPolicy Advocacy",
          desc: "FORPASI conducts research to provide policy input through policy briefs, lean research, and direct engagement with policymakers and other sector organisations (private and nonprofit/CSO)."
        },
        {
          title: "Education, Campaigns & Strategic Programmes",
          desc: "FORPASI provides volunteer programmes, educational activities, and campaigns to strengthen public understanding of waste, and supports strategic waste management programmes through Yayasan Asa Indonesia Lestari."
        },
      ],
      impactTitle: "FORPASI IN NUMBERS",
      impacts: [
        { icon: <FaUsers />, value: "950+", label: "Digital community members (WhatsApp)" },
        { icon: <FaInstagram />, value: "—", label: "Instagram followers" },
        { icon: <FaHandsHelping />, value: "30,000+", label: "Social media engagement" },
        { icon: <FaVideo />, value: "20", label: "Webinar & event recordings" },
        { icon: <FaUserFriends />, value: "45+", label: "Active volunteers" },
        { icon: <FaMapMarkedAlt />, value: "20", label: "Regions covered by coordinators" },
        { icon: <FaNetworkWired />, value: "20+", label: "Partner organisations" },
      ],
      mapTitle: "Programme Map & Collaboration Network (Tentative)",
      mapNote:
        "Map to be added (tentative). For now, use a placeholder or embed when available.",
      ctaTitle: "Want to participate directly?",
      ctaText:
        "We prepare activities for anyone who wants to contribute to advancing Indonesia’s waste-management system.",
      ctas: [
        { href: "https://www.indorelawan.org/organization/64f53040c147a300219891ec", text: "Become a Volunteer (Indorelawan)" },
        { href: "https://forms.gle/nLXwtjaML9hYB9iz8", text: "Become a Regional Coordinator" },
        { href: "https://www.instagram.com/forpasi_id/?hl=en", text: "Join WhatsApp Group (DM Instagram)" },
      ],
    },
  };

  const t = content[language] || content.id;

  return (
    <section className="programme-section">
      <div className="programme-container">
        {/* Hero */}
        <div className="programme-hero fade-in">
          <h2>{t.heroTitle}</h2>
          <p className="programme-strapline">{t.strapline}</p>
        </div>

        {/* Focus Areas */}
        <div className="programme-focus fade-in">
          <h3>{t.focusTitle}</h3>
          <div className="focus-grid">
            {t.focusList.map((item, idx) => (
              <div className="focus-card" key={idx}>
                <div className="focus-index">{String(idx + 1).padStart(2, '0')}</div>
                <div className="focus-details">
                  <p className="focus-title">{item.title}</p>
                  <div className="focus-image-wrap">
                    <img src={item.image} alt={item.title} className="focus-card-image" />
                  </div>
                  <p className="focus-desc">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Impact Tracker */}
        <div className="programme-impact fade-in">
          <h3>{t.impactTitle}</h3>
          <div className="impact-grid">
            {t.impacts.map((m, i) => (
              <div className="impact-item" key={i}>
                {m.icon && <div className="impact-icon">{m.icon}</div>}
                <h3>{m.value}</h3>
                <p>{m.label}</p>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="programme-cta fade-in">
          <div className="programme-cta-inner">
            <h2 className="cta-title">{t.ctaTitle}</h2>
            <p className="cta-subtitle">{t.ctaText}</p>
            <div className="cta-buttons">
              {t.ctas.map((c, i) => (
                <a
                  key={i}
                  href={c.href}
                  className={i === 0 ? "cta-button-primary" : "cta-button-secondary"}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {c.text}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProgrammeSection;
